import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import Datepicker from 'vuejs-datepicker'
import DropzoneGrader from '@/components/share/dropzone_grader'
import { ja } from 'vuejs-datepicker/dist/locale'
const Validator = require('validatorjs')
Validator.useLang('ja')

export default {
  name: 'skillCreate',
  components: {
    SharedHeader,
    SharedFooter,
    Datepicker,
    DropzoneGrader
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      loading: false,
      updating: false,
      error: {},
      isAlert: false,
      state: {},
      checker: {
        title: '',
        description: '',
        skill: [],
        time: '',
        criteria: [],
        prize: '',
        grader: {}
      },
      skill: '',
      timeOptions: [
        { value: 1, text: '15分' },
        { value: 2, text: '30分' },
        { value: 3, text: '1時間' },
        { value: 4, text: '3時間' },
        { value: 5, text: '1日' }
      ],
      criteriaIndex: 0,
      criteria: {
        '0': ['', '', ''],
        '1': ['発想の新規性', '論理性', '内容の信憑度'],
        '2': ['リサーチ力', '資料の分かりやすさ', '熱意'],
        '3': ['独創性', '実現性', '論理性']
      },
      ja: ja,
      selectDate: '',
      grader: {},
      isUpload: false
    }
  },
  mounted () {
    this.loading = false
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['bg-light', 'text-primary']
      } else {
        return ['bg-light']
      }
    },
    create () {
      this.updating = true
      let allState = true
      this.setTitleState()
      this.setDescriptionState()
      this.setSkillState()
      this.setTimeState()
      this.setCriteriaState()
      this.setEndDateState()

      for (let key in this.state) {
        if (allState) allState = this.state[key]
      }

      if (!allState) {
        this.error.message = '必須項目を入力してください'
        this.isAlert = true
        window.scrollTo(0, 0)
        this.updating = false
        this.isModal = false
      } else {
        this.isAlert = false

        let additionalParams = {
          queryParams: {
            type: 'draft'
          }
        }

        let body = this.checker
        if (!body.prize) delete body.prize
        for (let key in this.grader) {
          if (this.grader[key]) body.grader[key] = this.grader[key]
        }
        if (!Object.keys(body.grader).length) delete body.grader

        this.$apig.post(this.api.SKILL, {}, additionalParams, body)
          .then(response => {
            this.$router.push(`/skill/${response.data.skillId}`)
            this.updating = false
          })
          .catch(err => {
            console.log(err)
            this.error = err.response.data
            this.isAlert = true
            window.scrollTo(0, 0)
            this.updating = false
          })
      }
    },
    setTitleState () {
      let v = new Validator({
        'タイトル': this.checker.title
      }, {
        'タイトル': 'required|max:140'
      })

      let pass = v.passes()
      this.error.title = v.errors.first('タイトル')

      this.state.title = pass
    },
    setDescriptionState () {
      let v = new Validator({
        '説明': this.checker.description
      }, {
        '説明': 'required'
      })

      let pass = v.passes()
      this.error.description = v.errors.first('説明')

      this.state.description = pass
    },
    setSkillState () {
      if (!this.checker.skill.length) {
        this.state.skill = false
        this.error.skill = 'スキルは必須です。'
      } else {
        this.state.skill = true
      }
    },
    setTimeState () {
      let v = new Validator({
        '所要時間': this.checker.time
      }, {
        '所要時間': 'required'
      })

      let pass = v.passes()
      this.error.time = v.errors.first('所要時間')

      this.state.time = pass
    },
    setCriteriaState () {
      if (this.criteria['0'].length === 3 &&
        this.criteria['0'][0].length &&
        this.criteria['0'][1].length &&
        this.criteria['0'][2].length) {
        this.checker.criteria = this.criteria['0']
        this.state.criteria = true
      } else {
        this.state.criteria = false
        this.error.criteria = '採点基準は必須です。'
      }
    },
    setEndDateState () {
      let v = new Validator({
        '回答締切日': this.selectDate
      }, {
        '回答締切日': 'required'
      })

      let pass = v.passes()
      this.error.selectDate = v.errors.first('回答締切日')

      this.state.endDate = pass

      if (pass) {
        let dt = new Date(this.selectDate)
        this.checker.endDate = `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`
      }
    },
    getAvatar (avatarId) {
      return `${process.env.S3}/student/avatar/${avatarId}.png`
    },
    addSkill () {
      this.checker.skill.push(this.skill)
      this.skill = ''
    },
    removeSkill (item, key) {
      this.checker.skill.splice(key, '1')
    },
    getDropzoneData (data) {
      this.isUpload = data.isUpload
      this.grader.avatarId = data.avatarId
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/skill/create/create.js